'use strict';

const slideConfig = {
  items: [],
  sliderWidth: null,
  sliderHeight: null
};

export default slideConfig;
